import React from 'react';
import Hero from '../components/sections/Hero';
import BlooraFeature from '../components/sections/BlooraFeature';
import Mission from '../components/sections/Mission';
import ResearchHighlights from '../components/sections/ResearchHighlights';
import ForProfessionals from '../components/sections/ForProfessionals';
import TeamTeaser from '../components/sections/TeamTeaser';
import EarlyAccessTeaser from '../components/sections/EarlyAccessTeaser';

export default function Home() {
  return (
    <>
      <Hero />
      <BlooraFeature />
      <Mission />
      <ResearchHighlights />
      <ForProfessionals />
      <TeamTeaser />
      <EarlyAccessTeaser />
    </>
  );
}
